import { render, staticRenderFns } from "./ExpiredLink.vue?vue&type=template&id=1f09763e&scoped=true"
import script from "./ExpiredLink.vue?vue&type=script&lang=js"
export * from "./ExpiredLink.vue?vue&type=script&lang=js"
import style0 from "./ExpiredLink.vue?vue&type=style&index=0&id=1f09763e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f09763e",
  null
  
)

export default component.exports